import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';

const QUERY_PARAMS = [
  'countryCode',
].reduce((accum, param) => {
  accum[param] = { refreshModel: true, replace: true };
  return accum;
}, { });

class PayoutAddMethodPayoneerSetupRoute extends Route {
  @service router;

  get queryParams() {
    return QUERY_PARAMS;
  }

  /** @inheritDoc */
  model(params) {
    const { countryCode } = params;

    return {
      countryCode,
      payoutAccount: null,
    };
  }

  /** @inheritDoc */
  redirect(model) {
    if (!model.countryCode) {
      this.router.transitionTo('settings.payout.add-method');
    }
  }

  /** @inheritDoc */
  activate() {
    super.activate(...arguments);

    const settingsController = this.controllerFor('settings');
    settingsController.set('isUsingLegacySettingsFrame', false);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowSimpleHeader', true);
    applicationController.set('simpleHeaderText', 'Add a payout method');
    applicationController.set('simpleHeaderRightText', 'Cancel');
    applicationController.set('simpleHeaderRightAction', () => {
      this.router.transitionTo('settings.payout');
    });
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);

    const settingsController = this.controllerFor('settings');
    settingsController.set('isUsingLegacySettingsFrame', true);

    const applicationController = this.controllerFor('application');
    applicationController.set('isShowSimpleHeader', false);
    applicationController.set('simpleHeaderText', '');
    applicationController.set('simpleHeaderRightText', '');
    applicationController.set('simpleHeaderRightAction', null);
  }
}

export default PayoutAddMethodPayoneerSetupRoute;
